/**
 * Assumes that the last handle is the "no-match" handle
 * @param nodeId The current node id
 * @param handleId Handle id
 * @returns the propper split id like <nodeid>#split#handleId
 */
export function splitId(nodeId: string, handleId: string): string {
    return `${nodeId}#split#${handleId}`;
}
